import colors from './colors.json';

export default {
  colors,
  sizes: {
    screens: {
      xs: '400px',
      sm: '500px',
      md: '640px',
      lg: '1024px',
      xl: '1200px',
    },
  },
  gradients: {
    peoople: `linear-gradient(180deg, ${colors.primary['90']} 0%, ${colors.peoople['azul-claro-medio']} 100%)`,
    blue: 'linear-gradient(270deg, #5E3DFF 0%, #00CCF8 100%)',
    rookie: (direction = 'to left') => {
      return `linear-gradient(${direction}, #c4c4c4, #979797)`;
    },
    creator: (direction = 'to left') => {
      return `linear-gradient(${direction}, #5feb6e, #1ed6ae)`;
    },
    influencer: (direction = 'to left') => {
      return `linear-gradient(${direction}, #00ccf8, #5530ff)`;
    },
    unicorn: (direction = 'to left') => {
      return `linear-gradient(${direction}, #c55bff, #5800dd)`;
    },
    star: (direction = 'to left') => {
      return `linear-gradient(${direction}, #fac92b, #fa8e24)`;
    },
  },
  elevation: {
    base: '0px 4px 41px -5px rgba(128, 154, 211, 0.20);',
    peoople: '0px 0px 14.1px -2px rgba(195, 203, 217, 0.4)',
    small: '0px 0px 4.2px 4px #F8F9FC;',
  },
  typographies: {
    small: {
      'font-size': '12px',
    },
    buttons: {
      'font-size': '14px',
      'font-weight': '600',
    },
    light: {
      'font-size': '16px',
      'font-weight': 'light',
    },
    legal: {
      'font-size': '16px',
      'line-height': '2rem',
      'font-weight': '600',
    },
    default: {
      'font-size': '18px',
    },
    menu: {
      'font-size': '20px',
      'font-weight': '700',
    },
    title: {
      'font-size': '24px',
      'font-weight': '700',
    },
    big: {
      'font-size': '34px',
      'line-height': '30px',
      'font-weight': '700',
    },
  },
};
